import { render, staticRenderFns } from "./create-biller-account.vue?vue&type=template&id=2dd70221&"
import script from "./create-biller-account.vue?vue&type=script&lang=js&"
export * from "./create-biller-account.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports